import React, { Component } from 'react';
import './SearchBar.scss';
import { Icons } from '../../utilities';
import ColorSelector from '../ColorSelector/ColorSelector';
import { bindActionCreators } from 'redux';
import * as sideBarActions from '../../redux/sideBarActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import * as Constants from '../../utilities/constants/Constants';
import { string } from '../../localization';
import { connect } from 'react-redux';

class SearchBar extends Component {
  state = {
    searchedText: ''
  };

  componentDidMount() {
    const { dispatchers } = this.props;
    dispatchers.sideBarActions.setColorToSearch(null);
  }

  handleSearchChange = e => {
    this.setState({ searchedText: e.target.value });
  };

  keyPress = e => {
    if (e.keyCode === Constants.ENTER_KEY_CODE && e.target.value !== '') {
      this.onSearch(e.target.value);
    }
  };

  onSearch = searchKey => {
    const { dispatchers, searchTags } = this.props;

    if (searchKey !== null) {
      dispatchers.sideBarActions.setSearchTags(
        searchTags.updatedPatternColor,
        searchKey,
        0
      );
    }
  };

  onClose = () => {
    const { dispatchers } = this.props;

    this.setState({ searchedText: '' });
    dispatchers.sideBarActions.setSearchTags('clear', 'clear', 0);
    dispatchers.sideBarActions.searchBarHandler();
  };

  shouldDisplayColorSelector = name => {
    const { activeTab } = this.props;

    return (
      activeTab === Constants.BACKGROUND_TAB_KEY &&
      name !== Constants.GETTY_IMAGE &&
      name !== Constants.I_STOCK &&
      name !== Constants.DREAMSTIME &&
      name !== Constants.ADOBE_STOCK
    );
  };

  render() {
    const { name, colorToSearch, defaultColors, dispatchers } = this.props;
    const { searchedText } = this.state;

    const ColorSelectorStyle = {
      control: base => ({
        ...base,
        '&:hover': { borderColor: 'gray' },
        border: '1px solid rgb(128, 128, 128)',
        borderRadius: '0px',
        boxShadow: 'none',
        background: 'none'
      }),
      valueContainer: base => ({
        ...base,
        background: colorToSearch || `url(${Icons.clearColorImage})`,
        height: 30
      })
    };

    return (
      <div id='searchBar'>
        <div className='d-flex w-100'>
          <div className='d-flex w-100 position-relative'>
            <input
              className='search-feild'
              placeholder={string.SEARCH_TITLE}
              onChange={e => this.handleSearchChange(e)}
              onKeyDown={this.keyPress}
              value={searchedText}
            />
            <input
              type='image'
              src={Icons.searchDefault}
              className='search-icon'
              name='search'
              style={{ outline: 'none' }}
              onClick={() => this.onSearch(searchedText)}
              alt='search'
            />
          </div>
          <input
            type='image'
            src={Icons.closeHover}
            className='close-icon'
            name='Close'
            style={{ outline: 'none', cursor: 'pointer' }}
            onClick={() => {
              this.onClose();
            }}
            alt='Close'
          />

          {/* displayColorPicker= */}
          {this.shouldDisplayColorSelector(name) ? (
            <ColorSelector
              selectedColor={colorToSearch}
              pickerEnable
              label={string.CLEAR_COLOR_KEY}
              colors={defaultColors}
              style={ColorSelectorStyle}
              onClearColor={dispatchers.sideBarActions.setColorToSearch}
              onSelectColor={e =>
                dispatchers.sideBarActions.setColorToSearch(e)
              }
              placeholder={null}
            />
          ) : null}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    activeTab: state.sideBar.activeSideBarTab,
    folderListElements: state.sideBar.folderListElements,
    searchTags: state.sideBar.searchTags,
    defaultColors: state.modal.defaultColors,
    colorToSearch: state.sideBar.colorToSearch
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      sideBarActions: bindActionCreators(sideBarActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
